import { css, RuleSet } from 'styled-components'

export const media = {
  mobile: '(max-width: 640px)',
  tablet: '(max-width: 1024px)',
  desktop: '(max-width: 1600px)',
}

const breakpoints = {
  extraLargeDesktop: '1920px',
  largeDesktop: '1440px',
  desktop: '1280px',
  largeTablet: '1024px',
  tablet: '768px',
  mobile: '480px',
  smallMobile: '320px',
}

export const mediaQueries = {
  smallMobile: `only screen and (max-width: ${breakpoints.smallMobile})`,
  smallMobileAndDown: `only screen and (max-width: ${breakpoints.smallMobile})`,
  smallMobileAndUp: `only screen and (min-width: calc(${breakpoints.smallMobile} + 1px))`,
  mobile: `only screen and (min-width: ${breakpoints.smallMobile}) and (max-width: ${breakpoints.mobile})`,
  mobileAndDown: `only screen and (max-width: ${breakpoints.mobile})`,
  mobileAndUp: `only screen and (min-width: calc(${breakpoints.mobile} + 1px))`,
  tablet: `only screen and (min-width: ${breakpoints.mobile}) and (max-width: ${breakpoints.tablet})`,
  tabletAndDown: `only screen and (max-width: ${breakpoints.tablet})`,
  tabletAndUp: `only screen and (min-width: calc(${breakpoints.tablet} + 1px))`,
  largeTablet: `only screen and (min-width: ${breakpoints.tablet}) and (max-width: ${breakpoints.largeTablet})`,
  largeTabletAndDown: `only screen and (max-width: ${breakpoints.largeTablet})`,
  largeTabletAndUp: `only screen and (min-width: calc(${breakpoints.largeTablet} + 1px))`,
  desktop: `only screen and (min-width: ${breakpoints.largeTablet}) and (max-width: ${breakpoints.desktop})`,
  desktopAndDown: `only screen and (max-width: ${breakpoints.desktop})`,
  desktopAndUp: `only screen and (min-width: calc(${breakpoints.desktop} + 1px))`,
  largeDesktop: `only screen and (min-width: ${breakpoints.desktop}) and (max-width: ${breakpoints.largeDesktop})`,
  largeDesktopAndDown: `only screen and (max-width: ${breakpoints.largeDesktop})`,
  largeDesktopAndUp: `only screen and (min-width: calc(${breakpoints.largeDesktop} + 1px))`,
  extraLargeDesktop: `only screen and (min-width: ${breakpoints.largeDesktop}) and (max-width: ${breakpoints.extraLargeDesktop})`,
  extraLargeDesktopAndDown: `only screen and (max-width: ${breakpoints.extraLargeDesktop})`,
  extraLargeDesktopAndUp: `only screen and (min-width: calc(${breakpoints.extraLargeDesktop} + 1px))`,
}

export const extraLargeDesktopAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.extraLargeDesktopAndDown} {
    ${style}
  }
`

export const largeDesktopAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.largeDesktopAndDown} {
    ${style}
  }
`

export const desktopAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.desktopAndDown} {
    ${style}
  }
`

export const largeTabletAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.largeTabletAndDown} {
    ${style}
  }
`

export const largeTabletAndUp = (style: RuleSet) => css`
  @media ${mediaQueries.largeTabletAndUp} {
    ${style}
  }
`

export const tabletAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.tabletAndDown} {
    ${style}
  }
`

export const mobileAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.mobileAndDown} {
    ${style}
  }
`

export const smallMobileAndDown = (style: RuleSet) => css`
  @media ${mediaQueries.smallMobileAndDown} {
    ${style}
  }
`
